module.exports = __webpack_public_path__ + "static/media/curve-light.093e4b4b.svg";